module.exports = __webpack_public_path__ + "img/background-otp.5df46d4b.png";